import { useSyncExternalStore } from "react";

export const MOBILE_GRID_MEDIA_QUERY = "(max-width: 767.98px)";

function subscribe(listener: () => void) {
  const query = window.matchMedia(MOBILE_GRID_MEDIA_QUERY);
  query.addEventListener("change", listener);
  return function () { query.removeEventListener("change", listener); };
}

function snapshot() {
  return window.matchMedia(MOBILE_GRID_MEDIA_QUERY).matches;
}

export default function useMobileGrid() {
  return useSyncExternalStore(subscribe, snapshot, function () { return false; });
}
